import React, { useEffect, useState } from 'react';
// import './MyOrder.css';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
const AllOrder = () => {
    const [loader,setLoader] = useState(true);
    const [allOrder,setAllOrder] = useState([]);
    //fetch only login user order
    useEffect(()=>{
        axios.get(`https://fresh-trip.onrender.com/myorder/`)
        .then(res=>{
            setLoader(false);
            setAllOrder(res.data);
        }).catch(err=>{
            console.log(err);
        })
    },[allOrder]);
    //handle delete item
    const deleteItem = (id) => {
        confirmAlert({
            message: 'Are you sure! You want to Delete this ..',
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                    axios.delete(`https://fresh-trip.onrender.com/order/${id}`)
                    .then(res=>{
                        if(res.status === 200){
                            const remainOrder = allOrder.filter(item => item._id !== id);
                            setAllOrder(remainOrder);
                            toast.success("Order Deleted Successfully");
                        }
                    }).catch(err=>{
                        console.log(err);
                    });
                }
              },
              {
                label: 'No',
                onClick: () => {
                    toast('Your Item is safe :)');
                }
              }
            ],
            overlayClassName: "overley"
        });
    }
    //update order
    const updateStatus = (id) => {
        // console.log(id);
        const selectedItem = allOrder.find(item => item._id === id);
        if(selectedItem.status === 'pending'){
            selectedItem.status = 'confirm';
            axios.put(`https://fresh-trip.onrender.com/order/${id}`,selectedItem)
            .then(res=>{
                if(res.data.modifiedCount > 0){
                    toast('order is confirmed');
                }
            }).catch(err=>{
                console.log(err)
            });
        }else{
            selectedItem.status = 'pending';
            axios.put(`https://fresh-trip.onrender.com/order/${id}`,selectedItem)
            .then(res=>{
                if(res.data.modifiedCount > 0){
                    toast.success('order is revert to pending');
                }
            }).catch(err=>{
                console.log(err);
            });
        }
    }
    return (
        <>
            <Breadcrumb pageName='Manage All Order' formPage='Home' toPage='Manage All Order'></Breadcrumb>
            {
            loader?
            <div className="col text-center">
                <button className="btn btn-primary" type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                </button>
            </div>
            :
            <div className="container">
                <div className="row my-5">
                    <div className="col-md-12 m-auto">
                        <div className='myOrderArea'>
                            <h3 className='text-center'>All Order ({allOrder.length})</h3>
                            <div className="table-responsive">
                                {    
                                    allOrder.length > 0 ?
                                    <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Order_id</th>
                                            <th>Tourist Name</th>
                                            <th>Desitination</th>
                                            <th>Package</th>
                                            <th>Order_status</th>
                                            <th className='text-center'>Update Order</th>
                                            <th className='text-center'>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            allOrder.map(item=>
                                                <tr key={item._id}>
                                                    <td>{item._id}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.destination}</td>
                                                    <td>{item.duration} ${item.price}</td>
                                                    <td>
                                                        {
                                                            item.status === 'pending' ?
                                                            <span className="badge rounded-pill bg-warning text-dark">{item.status}</span>
                                                            :
                                                            <span className="badge rounded-pill bg-success text-white">{item.status}</span>
                                                        }
                                                    </td>
                                                    <td className='text-center'>
                                                        {
                                                            item.status === 'pending' ?
                                                            <button
                                                                onClick={()=>updateStatus(item._id)}
                                                                className='btn btn-success' title='confirm-order'>Confirm
                                                            </button>
                                                            :
                                                            <button
                                                                onClick={()=>updateStatus(item._id)}
                                                                className='btn btn-danger' title='confirm-order'>Revert
                                                            </button>
                                                        }
                                                        
                                                    </td>
                                                    <td className='text-center'>
                                                        <button
                                                            onClick={()=>deleteItem(item._id)}
                                                            className='btn-logout' title='delete'><i className="fas fa-trash-alt"></i>
                                                        </button>

                                                    </td>
                                                </tr>
                                            )
                                        }
                                        
                                    </tbody>
                                </table>
                                :
                                <h4 className="text-center py-5">Order Summery is Empty</h4>
                                }
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
            <ToastContainer />
        </>
    );
};

export default AllOrder;